import type { SystemDocumentEntry } from 'features/knowledgeDocumentViewer/types/systemDocumentEntries'
import { getSystemDocumentBqId } from 'features/knowledgeDocumentViewer/types/systemDocumentEntries'

/**
 * Resolve system-documents from an already-loaded site list by BQ document_id
 * (or legacy Rolodex entry UUID), preserving the order of `documentIds`.
 */
export function resolveSystemDocumentsFromList(
  entries: SystemDocumentEntry[],
  documentIds: string[]
): {
  found: SystemDocumentEntry[]
  missingIds: string[]
} {
  if (documentIds.length === 0) {
    return { found: [], missingIds: [] }
  }

  const byBqId = new Map<string, SystemDocumentEntry>()
  const byEntryId = new Map<string, SystemDocumentEntry>()
  for (const entry of entries) {
    byEntryId.set(entry.entry.id, entry)
    const bqId = getSystemDocumentBqId(entry)
    if (bqId) {
      byBqId.set(bqId, entry)
    }
  }

  const found: SystemDocumentEntry[] = []
  const missingIds: string[] = []
  for (const documentId of documentIds) {
    const match = byBqId.get(documentId) ?? byEntryId.get(documentId)
    if (match) {
      found.push(match)
    } else {
      missingIds.push(documentId)
    }
  }

  return { found, missingIds }
}
